import {Component} from "react";
import { Layout, message,  Space,  Dropdown, Menu, Spin} from "antd";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavFooter from "../../components/NavFooter";

import '../css/main.less'
import React from "react";
import AxiosUtil from "../../utils/AxiosUtil";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import TaskList from "./components/TaskList";
import {TaskProps} from "./model/aireport";
import AiInputForm from "./components/AiInputForm";
import {CarryOutOutlined} from "@ant-design/icons";

const {Content} = Layout;

interface IProps {
}

export default class TaskCheck extends Component<IProps> {

    taskListRef: TaskList | undefined;
    onTaskListRef = (ref: any) => {
        this.taskListRef = ref;
    }

    aiInputRef: AiInputForm | undefined;
    onAiInputRef = (ref: AiInputForm) => {
        this.aiInputRef = ref;
    }

    state = {
        autoList: [],
        autoSum: 0,
        autoTotal: 0,
        manualUser: '',

        showTaskManual: false,
        showTaskAuto: false,

        loadingAuto: false,
        loadingCheck: false
    }

    componentDidMount() {
        //组件加载完成后触发
        //console.log('dataUserList',this.taskListRef?.state.dataUserList)
    }

    render() {
        const crumb = [
            {name: '智能研报'},
            {name: '查询审核'},
        ];


        const clickCheckSuccess = () => {
            this.postCheckByStatus(3);
        };
        const clickCheckOthers = (e: any) => {
            this.postCheckByStatus(e.key);
        }
        const actionSubMenu = (
            <Menu onClick={clickCheckOthers}>
                <Menu.Item key="0">未分配</Menu.Item>
                <Menu.Item key="1">已分配</Menu.Item>
                {/* <Menu.Item key="2">已完成</Menu.Item>
                <Menu.Item key="11">无需处理</Menu.Item>
                <Menu.Item key="12">任务取消</Menu.Item> */}
            </Menu>
        );
        const actionMenu = (
            <Spin spinning={this.state.loadingCheck}>
                <Dropdown.Button key="3"
                                 type="primary"
                                 onClick={clickCheckSuccess}
                                 overlay={actionSubMenu}>
                    <CarryOutOutlined/> 审核通过
                </Dropdown.Button>
            </Spin>
        );
        return (
            <Layout>
                <NavHeader/>
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>
                            <div id="toolBar">
                                <Space size={32}>
                                    <span>批量操作：</span>
                                    {actionMenu}

                                </Space>
                            </div>

                            <TaskList ref={this.onTaskListRef}
                                      onEdit={this.openInputter}
                                //onCheck={this.openInputter}
                                      queryStatus={'2'}
                                      queryUser={''}
                            />

                            <AiInputForm ref={this.onAiInputRef}
                                         onClose={this.closeInputter}
                            />
                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>
        );
    }

    openInputter = (task: TaskProps) => {
        console.log('onInputClick', task);
        this.aiInputRef?.openInputter(task);
    };
    closeInputter = (reload: boolean) => {
        if (reload) {
            this.taskListRef?.loadMainData();
        }
    };

    postCheckByStatus = (key: number) => {
        this.setState({loadingCheck: true})
        if (this.taskListRef?.state.selectedTasks.length === 0) {
            message.error({content: '请至少选择一条要审核的任务！', className: 'message_error'});
            return;
        }

        const callback = (suc: boolean, dat: any) => {
        this.setState({loadingCheck: false})
        if (suc) {
                message.warning({content:dat, className: 'message_success'});
                this.taskListRef?.loadMainData();
            }
            this.setState({showLoading: false});
        }
        const queryParam = {
            list: this.taskListRef?.state.selectedTasks,
            taskStatus: key
        };
        AxiosUtil.AxiosRequest("/api/ybTask/updateTaskStatusById", queryParam, callback);
    }
}